import schoolInvoiceFormApis from '@modules/school-service/apis/school-invoice-form.api';
import { ISchoolInvoiceForm } from '@modules/school-service/interfaces/school-invoice-form.interface';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const INVOICE_FORM_QUERY_KEY = 'invoiceForm';

export const useInvoiceFormListQuery = (filterParams: {
    currentPage: number;
    keyword?: string;
}) =>
    useQuery<{ list: ISchoolInvoiceForm[]; total: number }>({
        queryKey: [INVOICE_FORM_QUERY_KEY, filterParams],
        placeholderData: { list: [] as ISchoolInvoiceForm[], total: 0 },
        enabled: filterParams.currentPage > 0,
        queryFn: async () => {
            const { status, data } =
                await schoolInvoiceFormApis.getList(filterParams);
            let apiData = { list: [], total: 0 };
            if (status === 200) {
                apiData = data?.data;
            }
            return apiData;
        },
    });

/**===================================
 * Chỉnh sửa phân hiệu
 ===================================*/
export const useUpdateInvoiceFormMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (dataSubmit: ISchoolInvoiceForm) => {
            const response = await schoolInvoiceFormApis.update(dataSubmit);

            if (response.status !== 200) {
                throw new Error(response.data?.msg || 'Có lỗi xảy ra');
            }
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [INVOICE_FORM_QUERY_KEY],
            });
        },
    });
};
